var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipientHousehold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7356_375755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501 171.441L256 23.095L11 171.441",
    stroke: "#282F3B",
    strokeWidth: 22,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.101 114.255V61.047H476.247V157.074",
    stroke: "#282F3B",
    strokeWidth: 22,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.555 244.847C381.78 237.844 382.383 231.806 382.383 224.626C382.383 205.942 367.236 190.795 348.552 190.795C329.868 190.795 314.721 205.942 314.721 224.626C314.721 232.175 316.024 238.401 322.132 245.398",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.396 483.403V415.866C97.396 378.526 127.667 348.255 165.007 348.255C189.206 348.255 209.167 360.264 221.112 379.375",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.047 378.618C305.099 360.434 325.102 347.787 348.552 347.787C385.729 347.787 415.867 377.925 415.867 415.102V486.363",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.935 347.295C385.092 343.212 405.418 316.264 401.335 287.107C397.251 257.95 370.304 237.624 341.146 241.708C311.989 245.791 291.663 272.738 295.747 301.896C299.83 331.053 326.778 351.379 355.935 347.295Z",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.657 259.607C374.039 282.095 352.878 292.278 328.789 292.278C318.007 292.278 306.962 289.343 298.131 284.501",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.733 345.263C210.637 335.475 225.323 304.919 215.534 277.015C205.746 249.11 175.19 234.425 147.286 244.213C119.382 254.001 104.696 284.557 114.484 312.461C124.272 340.366 154.828 355.051 182.733 345.263Z",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.635 422.979C276.254 422.979 292.158 407.075 292.158 387.456C292.158 367.837 276.254 351.933 256.635 351.933C237.016 351.933 221.112 367.837 221.112 387.456C221.112 407.075 237.016 422.979 256.635 422.979Z",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.433 486.363V472.178C207.433 445.006 229.46 422.979 256.632 422.979C283.804 422.979 305.831 445.006 305.831 472.178V483.897",
    stroke: "#4F4FAB",
    strokeWidth: 22,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 156.301V488.905H476.247V157.074",
    stroke: "#282F3B",
    strokeWidth: 22,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7356_375755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientHousehold);
export default __webpack_public_path__ + "static/media/recipient_household.f2e1501f2395bca1a3672740e318cafb.svg";
export { ForwardRef as ReactComponent };